// extracted by mini-css-extract-plugin
export var statItem = "_hy-1";
export var statsRow = "_hy-0";